import { useState } from 'react';
import '../../styles/Home.css';
import STEAMnav from '../../nav/STEAM-Nav';
import Wip from '../.././wip';

const STEAM2024 = () => {

  return (



    <div className="container">

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/FBT.png" alt="" width="40%" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/IWU.png" alt="" width="40%" className="rounded" /></p>
        </div>

      </div>

      <div>
        <h4 className="center-align"><b><u>STEAM Olympics 2025 - Design-athon</u></b></h4>
      </div>
      <h6 ></h6>
      <p >&nbsp;</p>
      <div>
        <h5 className="justify c737373"><b >Introducing the Design-athon – A STEAM Olympics Event!</b></h5>
      </div>

      <div>
        <h5 className="justify c737373">For A Better Tomorrow is thrilled to host the <b>Design-athon</b>, a two-day immersive event designed to inspire creativity, collaboration, and problem-solving among students in grades 6 through 12. This event, in collaboration with industry mentors and STEAM experts, offers students the chance to learn, create, and compete in a hands-on design challenge inspired by real-world applications of AI, machine learning, and more.</h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Activity Overview</b></h4>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <ul>
            <li ><b>Day 1 (Saturday, March 1<sup>st</sup> 1 - 5 pm): Interactive Learning Sessions</b><br />
              Students will kick off with short learning sessions on cutting-edge topics led by STEAM professionals. Participants can choose from topics like <b>AI Basics, Computer Vision, Machine Learning, Natural Language Processing (NLP),</b> and <b>AI in Gaming</b>. These sessions will be tailored for middle and high school students with minimal prior experience, ensuring a foundation of hands-on learning and exploration.</li>
            <li ><b>Day 2 (Sunday, March 2<sup>nd</sup> 12:30-5:30 pm): Team-Based Design Challenge and Competition</b><br />
              Teams of 3-4 students will work on a STEAM-related project for 2-3 hours, supported by mentors. Guided by their selected prompt or thought starter, teams will tackle a unique challenge, applying concepts from their learning sessions. Each team will be mentored by a speaker or industry expert, ensuring a supportive and enriching experience.
              At the end of the day, teams will pitch their projects to a panel of judges in a <b>5-10 minute presentation</b>, "Shark Tank" style. Judges will evaluate creativity, technical skill, and overall impact, with prizes awarded to winning teams.</li>
          </ul>

        </div>

      </div >

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Participation Options</b></h4>
          <h5 className="justify c737373"><i >The Design-athon is open for both <b>in-person</b> and <b>virtual</b> participation, with in-person locations available in <b>Bloomington, Dallas, Atlanta,</b> and <b>Phoenix</b>. Virtual attendance is available for students from other regions based on registration.</i></h5>
        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Registration and Team Formation</b></h4>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">

          <ul>
            <li ><b>Sign up individually or as a team!</b> Individuals will have the opportunity to be paired with a team if needed.</li>
            <li >Choose a <b>prompt or thought starter</b> upon registration to guide your learning session choices and project direction.</li>
          </ul>

        </div>

      </div >

      <p >&nbsp;</p>
      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Interested in Participating?</b></h4>
          <h5 className="center-align"><i >Secure your spot by registering here. Early registration discounts are available! Sibling discount will be made available in the upcoming weeks.</i></h5>
          <p >&nbsp;</p>
          <h5 className="center-align"><a type="button" class="btn btn-primary btn-lg" href="http://tinyurl.com/steam-fbt">Register here</a></h5>
          <p >&nbsp;</p>
          <div className="row">

            <div className="col-sm">
              <p className="center-align"><a href="/flyer/STEAM-2025-designathon-blm"> <img src="/images/flyers/STEAM-2025-Designathon-BLM.png" alt="" width="150" height="200" class="rounded" /> </a></p>
              <h5 className="center-align"><a href="/flyer/STEAM-2025-designathon-blm">Bloomington, IL</a></h5>
            </div>

            <div className="col-sm">
              <p className="center-align"><a href="/flyer/STEAM-2025-designathon-tx"> <img src="/images/flyers/STEAM-2025-Designathon-TX.png" alt="" width="150" height="200" class="rounded" /> </a></p>
              <h5 className="center-align"><a href="/flyer/STEAM-2025-designathon-tx">Frisco, TX</a></h5>
            </div>

            <div className="col-sm">
              <p className="center-align"><a href="/flyer/STEAM-2025-designathon-virtual"> <img src="/images/flyers/STEAM-2025-Designathon-Virtual.png" alt="" width="150" height="200" class="rounded" /> </a></p>
              <h5 className="center-align"><a href="/flyer/STEAM-2025-designathon-virtual">Virtual</a></h5>
            </div>

          </div>

          <p >&nbsp;</p>
          <h5 className="center-align"><b >Get Ready to Innovate</b></h5>
          <h5 className="center-align"><i >Join us for a collaborative, hands-on experience in the world of STEAM and compete to bring your ideas to life. We can’t wait to see what you create at the Design-athon!</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

    </div>




  );
}
export default STEAM2024;
